<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('departments')"
      :columns="columns"
      :column_search="false"
      resource_url="/staff/department/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
    <department-modal ref="department_modal" @success="refresh" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date_time,
  format_date,
  format_currency,
} from "@/utils";
import DepartmentModal from "./department_modal/Index.vue";

export default {
  name: "DepartmentDatatable",
  components: { GenericTable, DepartmentModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: this.$t("name"),
          name: "name",
          data: (row) => row.name || "-",
        },
        {
          title: this.$t("description"),
          name: "description",
          data: (row) => row.description || "-",
        },
        {
          title: this.$t("budget"),
          name: "budget",
          data: (row) => {
            if (
              row.settings &&
              row.settings.budget &&
              row.settings.budget > 0
            ) {
              return format_currency(row.settings.budget);
            }
            return this.$t("not defined");
          },
        },
        {
          title: this.$t("status"),
          name: "status",
          data: (row) => {
            var status_class =
              row.status === "active" ? "is-success" : "is-danger";
            var status_text = this.$t(row.status);
            return `<span class="tag ${status_class}">${status_text}</span>`;
          },
        },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.department_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete department?"),
                    v,
                    () => {
                      del("/staff/department", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    // format_date_time,
    create() {
      let v = this;
      v.$refs.department_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
